import { NodeWrapper } from "./NodeWrapper";
import { mkHeaderStyle, HEADER_ICON_STYLE, HEADER_TEXT_STYLE, NODE_BODY_STYLE, NODE_INFO_ROW, OUTPUT_ROW_STYLE, OUTPUT_LABEL_STYLE } from "./nodeStyles";
import { ContentCopyOutlined as ContentCopy, DeleteOutlined as Delete, PaymentOutlined as Payment } from '@mui/icons-material';
import React, { memo } from "react";
import { Tooltip, Chip } from "@mui/material";
import { i18n } from "../../../translate/i18n";
import { Schedule as ScheduleIcon, GridOnOutlined as GridOn } from "@mui/icons-material";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";

import { Tooltip as CoreTooltip, IconButton as CoreIconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';










const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
  },
  arrow: { color: '#1e293b' },
}))(CoreTooltip);

const useStyles = makeStyles((theme) => ({
  pulseIcon: {
    color: '#ffffff',
    borderRadius: '50%',
    animation: '$glowPulse 1.5s infinite',
  },
  '@keyframes glowPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.9)' },
    '70%': { boxShadow: '0 0 0 8px rgba(255, 255, 255, 0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' },
  },
}));

export default memo(({
  data,
  isConnectable,
  id,
  selected
}) => {
  const classes = useStyles();
const storageItems = useNodeStorage();
  return <NodeWrapper id={id} selected={selected} color="#06B6D4">
      <Handle type="target" position="left" isConnectable={isConnectable} style={{ background: "#06B6D4", width: "10px", height: "20px", borderRadius: "4px", left: "-12px", cursor: "pointer", border: "2px solid white", top: "20px" }} />
            <div style={{ ...mkHeaderStyle("#06B6D4"), justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <Payment style={HEADER_ICON_STYLE} />
                <div style={HEADER_TEXT_STYLE}>{data?.name || "Reconocimiento Pago"}</div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                {data.remarketingEnabled && data.remarketingTasks?.length > 0 && <Tooltip title={`${i18n.t("flowBuilder.remarketing.title")} (${data.remarketingTasks?.length || 0})`}>
                    <Chip icon={<ScheduleIcon style={{ color: '#d97706', fontSize: 13 }} />} label={data.remarketingTasks?.length || 0} size="small" sx={{ height: 20, fontSize: '0.7rem', backgroundColor: '#fef3c7', color: '#d97706', fontWeight: 'bold', border: '1px solid #fde68a' }} />
                </Tooltip>}
                <HtmlTooltip
          arrow
          title={
            <React.Fragment>
              <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#22d3ee' }}>
                💡 {i18n.t("flowBuilder.tooltips.paymentValidation.title")}
              </div>
              <div style={{ marginBottom: '0' }}>
                <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.paymentValidation.body") }} />
              </div>
            </React.Fragment>
          }
          placement="right"
        >
          <CoreIconButton size="small" style={{ padding: '4px', marginLeft: '2px' }} className={classes.pulseIcon}>
            <HelpOutlineIcon style={{ fontSize: '15px' }} />
          </CoreIconButton>
        </HtmlTooltip>
      </div>
            </div>
            <div style={NODE_BODY_STYLE}>
                {/* Caja de Info */}
                <div style={{ ...NODE_INFO_ROW, display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '12px' }}>
                    <span style={{ fontSize: "11px", fontWeight: "600", color: "#64748b" }}>Proveedor:</span>
                    <span style={{ fontSize: "12px", color: "#1a1a1a" }}>
                        {data.provider ? (data.provider === 'openai' ? 'OpenAI' : 'Gemini') + ' - ' + data.model : "No configurado"}
                    </span>
                </div>

                {/* Salida de Éxito */}
                <div style={OUTPUT_ROW_STYLE}>
                    <span style={{ ...OUTPUT_LABEL_STYLE, color: '#059669', fontWeight: 'bold' }}>ÉXITO</span>
                    <Handle type="source" position="right" id="success" style={{
                        background: "#059669",
                        width: "10px",
                        height: "20px",
                        borderRadius: "4px",
                        right: "-12px",
                        cursor: "pointer",
                        border: '2px solid white',
                        top: "50%",
                        transform: "translateY(-50%)"
                    }} isConnectable={isConnectable} />
                </div>

                {/* Salida de Error */}
                <div style={OUTPUT_ROW_STYLE}>
                    <span style={{ ...OUTPUT_LABEL_STYLE, color: '#dc2626', fontWeight: 'bold' }}>ERROR</span>
                    <Handle type="source" position="right" id="error" style={{
                        background: "#dc2626",
                        width: "10px",
                        height: "20px",
                        borderRadius: "4px",
                        right: "-12px",
                        cursor: "pointer",
                        border: '2px solid white',
                        top: "50%",
                        transform: "translateY(-50%)"
                    }} isConnectable={isConnectable} />
                </div>
            </div>
        
        {/* Remarketing Handles Section */}
        {data.remarketingEnabled && data.remarketingTasks && data.remarketingTasks.length > 0 && <div style={{
      borderTop: "1px solid #f1f5f9"
    }}>
            <div style={{
        padding: "8px 12px",
        backgroundColor: "#fef3c7",
        fontSize: "11px",
        fontWeight: 400,
        fontFamily: "'Inter', 'Roboto', sans-serif",
        color: "#b45309",
        
      }}>
              {i18n.t("flowBuilder.remarketing.title") || "Remarketing"}
            </div>

            {[...data.remarketingTasks].sort((a, b) => (a.order || 0) - (b.order || 0)).map((task, index, array) => {
        const isFinal = task.isFinalTask || task.closeTicket; // Detect final task
        const isLastItem = index === array.length - 1;
        const isInactive = task.active === false;

        const bgStyle = isFinal ? "#fff0f5" : "white";
        return <div key={`${task.id}-${index}`} style={{
          position: "relative",
          padding: "8px 20px 8px 12px",
          borderBottom: !isLastItem ? "1px solid #f1f5f9" : "none",
          borderLeft: isFinal ? "4px solid #e91e63" : "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: bgStyle,
          fontSize: "12px",
          color: "#334155",
          borderBottomLeftRadius: isLastItem ? "10px" : "0",
          borderBottomRightRadius: isLastItem ? "10px" : "0",
          opacity: isInactive ? 0.6 : 1,
          textDecoration: isInactive ? "line-through" : "none"
        }}>
                    <div style={{
            flex: 1,
            marginRight: "40px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            overflow: 'hidden'
          }}>
                      <div style={{
              display: "flex",
              flexDirection: "column",
              minWidth: "30px",
              gap: "4px"
            }}>
                        {isFinal ? <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px"
              }}>
                            <GridOn style={{
                  width: "14px",
                  height: "14px",
                  color: "#880e4f"
                }} />
                            <span style={{
                  fontWeight: "bold",
                  fontFamily: "'Inter', 'Roboto', sans-serif",
                  color: "#e91e63",
                  fontSize: "12px"
                }}>
                              {i18n.t("flowBuilder.remarketing.fin") || "FIN"}
                            </span>
                            <span style={{
                  fontFamily: "'Inter', 'Roboto', sans-serif",
                  fontSize: '11px',
                  fontStyle: 'italic',
                  color: '#e91e63',
                  marginLeft: "8px"
                }}>
                              {i18n.t("flowBuilder.remarketing.autoClose") || "Auto-Cierre"}
                            </span>
                          </div> : <span style={{
                fontWeight: 500,
                fontFamily: "'Inter', 'Roboto', sans-serif",
                color: "#b45309",
                fontSize: "11px"
              }}>
                            {isInactive ? i18n.t("flowBuilder.remarketing.inactiveTask") || "[INACTIVA]" : `#${task.order || index + 1}`}
                          </span>}
                        <span style={{
                fontFamily: "'Inter', 'Roboto', sans-serif",
                fontSize: "11px",
                color: isFinal ? "#e91e63" : "#64748b"
              }}>
                          {task.waitUnit === 'days' ? `${task.waitTime}d` : task.waitUnit === 'hours' ? `${task.waitTime}h` : task.waitUnit === 'minutes' ? `${task.waitTime}m` : `${task.waitTime}m`}
                        </span>
                      </div>

                      {task.variable && !isFinal && <Chip label={task.variable} size="small" sx={{
              height: 22,
              fontSize: '0.75rem',
              bgcolor: '#fff',
              color: '#f59e0b',
              border: '1px solid #e2e8f0',
              '& .MuiChip-label': {
                px: 1.5
              }
            }} />}

                      {isFinal && <span style={{
              fontSize: '10px',
              fontStyle: 'italic',
              color: '#ad1457'
            }}>
                          {i18n.t("flowBuilder.remarketing.automaticTag") || "Automática"}
                        </span>}
                    </div>

                    <Handle type="source" position="right" id={`remarketing-${task.order}`} style={{
            background: isFinal ? "#e91e63" : "#f59e0b",
            width: 10,
            height: 20,
            borderRadius: "4px",
            right: -12,
            cursor: 'pointer',
            border: '2px solid white',
            zIndex: 10
          }} isConnectable={isConnectable} />
                  </div>;
      })}
          </div>}
  
        </NodeWrapper>;
});
